import { sendDataToGa4 } from './ga4-push-to-gtm';


/**
 * Get data from course card element
 *
 * @param {object}      data      Json object with data for GA
 * @param {HTMLElement} element   Element with "course-card" class
 * @param {int}         index     Index of element
 * @param {string}      list_name Item list name GA4 parameter
 * @param {string}      list_id   Item list id GA4 parameter
 */
export const getDataFromCourseCard = ( data, element, index, list_name, list_id ) => {

    const item = {            
        item_name: '',
        item_list_name: list_name,
        item_list_id: list_id,
        quantity: '1'
    }

    const priceStr = element.querySelector( '.course-card__price .amount' ).textContent;
    const priceNum = parseFloat( priceStr.match(/\d+/)[0] ).toFixed(2);

    item.item_name = element.querySelector( 'h3' ).textContent;
    item.item_id = element.getAttribute( 'id' );
    item.price = priceNum;
    item.item_category = element.getAttribute( 'type' );
    item.item_category2 = element.getAttribute( 'category' );
    item.item_category3 = element.getAttribute( 'topic' );
    item.index = index + 1;

    data.ecommerce.items.push( item );
}

/**
 * Get data when user scrolled to the element
 */
const observer = new IntersectionObserver( ( entries ) => {

    const eventsSection = entries[0];

    if ( eventsSection.isIntersecting ) {

        let listName = '';
        let listId = '';

        if ( window.location.pathname === '/' ) {
            listName = 'Najbliższe wydarzenia';
        }

        if ( window.location.pathname === '/szkolenia/' ) {
            listName = 'Strona: Szkolenia - wszystkie';
        }

        if ( window.location.pathname === '/live-meetingi/' ) {
            listName = 'Strona: Live Meetingi - wszystkie';
        }

        listId = convertNameToId(listName);

        const storage = sessionStorage.getItem( listId );

        const dataForGA = {
            event: 'view_item_list',
            item_list_name: listName,
            item_list_id: listId,
            ecommerce: {                         
              items: []
            }
        }

        const eventsList = document.querySelector( '.kb-main-courses' );

        let trainings = [];

        if ( ( screen.width < 768 || window.innerWidth < 768 ) ) {
            trainings = eventsList.querySelectorAll( '.owl-item:not(.cloned) .course-card' );
        } else {
            trainings = eventsList.querySelectorAll( '.course-card' );
        }

        trainings.forEach( ( training, index ) => {
            getDataFromCourseCard( dataForGA, training, index, listName, listId );

            training.addEventListener( 'click', () => {
        
                dataForGA.event = 'select_item';
                dataForGA.ecommerce.items = [];
                delete dataForGA.item_list_name;
                delete dataForGA.item_list_id;
    
                getDataFromCourseCard( dataForGA, training, index, listName, listId );
                sendDataToGa4( dataForGA );
            })
        } )

        if ( storage !== 'item-list-viewed' ) {
            sendDataToGa4( dataForGA );
        }

        sessionStorage.setItem( listId, 'item-list-viewed' );
    }

} );

/**
 * Check if user scrolled to the element
 */
const observeUpcomingEvents = () => {

    const body = document.querySelector( 'body' );

    if ( body.classList.contains( 'page-template-baza-wiedzy' ) || body.classList.contains( 'single-sm_trainer' ) ) {
        return;
    }

	const eventsSection = document.querySelector( '.kb-main-courses' );

    if ( eventsSection ) {
        observer.observe( eventsSection );
    }
	
}

/**
 * Get data on payment confirmation page
 */
const getDataOnPaymentConfirmationPage = () => {

    if ( ! window.location.pathname.includes( '/order-received/' ) ) {
        return;
    }   
    if( document.body.contains( document.querySelector( '[data-ga4-payload]' ) ) ) {
        const payload = document.querySelector( '[data-ga4-payload]' ).getAttribute( 'data-ga4-payload' );
        const json = JSON.parse( payload );
        const id = json.ecommerce.transaction_id;
        const storage = sessionStorage.getItem( `purchase_event-${id}` );
        if ( storage !== 'sent') {
            sendDataToGa4( json );
            sessionStorage.setItem( `purchase_event-${id}`, 'sent' );
        }
    }

}

/**
 * Get data on single product page
 * 
 * @param {string} event Name of GA4 event
 */
const getDataOnProductPage = ( event ) => {

    if ( ! document.querySelector( 'body' ).classList.contains( 'single-sm_training' ) ) {
        return;
    }

    const name = document.querySelector( 'h1' ).textContent;
    const type = document.querySelector( 'main > article' ).getAttribute( 'type' );
    const category = document.querySelector( 'main > article' ).getAttribute( 'category' );
    const topic = document.querySelector( 'main > article' ).getAttribute( 'topic' );

    const select = document.getElementById( 'termins-select' );
    let id = '';

    if ( select ) {
        id = select.value;
    }

    const terminPrice = document.getElementById( 'termin-price' );
    let priceStr, priceNum = '';

    if ( terminPrice ) {
        priceStr = terminPrice.textContent;
        priceNum = parseFloat( priceStr.match(/\d+/)[0] );
    }

    const dataForGA = {
        event: event,
        ecommerce: {
            currency: 'PLN',
            value: priceNum,
            items: [{
                item_name: name,
                item_id: id,
                price: priceNum,
                item_category: type,
                item_category2: category,
                item_category3: topic,
                index: 1,
                quantity: '1'
            }]
        }
    }

    if ( event === 'add_payment_info' ) {
        const id = document.getElementById( 'summary-termin' ).getAttribute( 'data-termin' );
        const coupon = document.querySelector( '.discount-content .validCode' );
        const quantity = document.querySelector( '.summary-content .summary-field-name:first-of-type .summary-field-value' ).textContent;
        const traditionalTransfer = document.querySelector( '.payment-method.traditionalBankTransfer' );
        const onlineTransfer = document.querySelector( '.payment-method.przelewy24' );

        dataForGA.ecommerce.items[0].item_id = id;
        dataForGA.ecommerce.items[0].quantity = quantity;

        if ( parseInt(quantity) > 1 ) {
            dataForGA.ecommerce.value = ( priceNum * parseInt(quantity) ).toFixed(2);
        }

        if ( coupon ) {
            const discountStr = document.querySelector( '.summary-discount-field-value' ).textContent;
            const discountNum = parseFloat( discountStr.match(/\d+/)[0] );

            dataForGA.ecommerce.coupon = coupon.textContent.replace( ' ', '' );
            dataForGA.ecommerce.value = ( priceNum * parseInt(quantity) - discountNum ).toFixed(2);
        }
    
        if ( traditionalTransfer.classList.contains( 'active' ) ) {
            dataForGA.ecommerce.payment_type = 'Przelew bankowy';
        } else if ( onlineTransfer.classList.contains( 'active' ) ) {
            dataForGA.ecommerce.payment_type = 'Przelewy24';
        }
    }

    sendDataToGa4( dataForGA );

}

/**
 * Call function to send event if user clicked on "zapisz się" button
 */
const controlBeginCheckoutEvent = () => {

    if ( ! document.querySelector( 'body' ).classList.contains( 'single-sm_training' ) ) {
        return;
    }

    const button = document.querySelector( '.panel1 .assign-button' );

    if ( ! button ) {
        return;
    }

    const select = document.getElementById( 'termins-select' );

    button.addEventListener( 'click', () => {

        const id = select.value;
        const storage = sessionStorage.getItem( `begin_checkout-${id}` );

        if ( storage !== 'sent' ) {
            getDataOnProductPage( 'begin_checkout' );

            sessionStorage.setItem( `begin_checkout-${id}`, 'sent' );
        }
    } );
}

/**
 * Call function to send event if user clicked on order button
 */
const controlPaymentInfoEvent = () => {

    if ( ! document.querySelector( 'body' ).classList.contains( 'single-sm_training' ) ) {
        return;
    }

    const saleform = document.querySelector( '.saleForm-container' );

    setTimeout(function() {

        const orderButton = saleform.querySelector( '.btn-submit button[type="submit"]' );

        if ( ! orderButton ) {
            return;
        }

        orderButton.addEventListener( 'click', () => {
            getDataOnProductPage( 'add_payment_info' );
        } );

    }, 200);

}

/**
 * Convert text to string with only lowercase, no polish characters, dashes and colons.
 * 
 * @param {string} name Text to convert
 */
export function convertNameToId( name ) {

    const nospaces = name.replaceAll(' - ', '-').replaceAll(' ', '-').replaceAll(':', '');
    const lowerchars = nospaces.toLowerCase();
    const nopolishchars = lowerchars.replaceAll('ą', 'a').replaceAll('ć', 'c').replaceAll('ę', 'e').replaceAll('ł', 'l').replaceAll('ń', 'n').replaceAll('ó', 'o').replaceAll('ś', 's').replaceAll('ż', 'z').replaceAll('ż', 'ż');

    return nopolishchars;
}


window.addEventListener( 'DOMContentLoaded', () => {
    observeUpcomingEvents();
    getDataOnPaymentConfirmationPage();
    getDataOnProductPage( 'view_item' );
    controlBeginCheckoutEvent();
} )

window.addEventListener('popstate', () => {

    if ( document.location.hash === '#step2' ) {
        controlPaymentInfoEvent();
    }

})
